<template>
  <v-container fluid class="px-0 py-0 cc-video-viewer">
    <div
      id="video-container"
      style="width:100%;height:350px;"
    >
    </div>
    <p v-if="name">{{name}}</p>
  </v-container>
</template>

<script>
  export default {
    name: "cc-video-viewer",
    props: {
      cfg: Object
    },
    watch: {
      cfg(val, old) {
        if (val.movieUrl) {
          if (!(old.movieUrl && old.movieUrl.ccvid == val.movieUrl.ccvid)) {
            this.init();
          }
        }
      }
    },
    data() {
      return {
        movieUrl: null,
        name: null
      };
    },
    methods: {
      destroyVideo() {
        if(window.cc_js_Player) {
          window.cc_js_Player.destroy()
        }
        if(window.videoManager && window.videoManager.videoObjBuffer.length) {
          setTimeout(() => {
            window.videoManager.videoObjBuffer.forEach(ele => {
              ele.videoElement.pause()
            })
          }, 500)
        }
      },
      init() {
        let self = this,
          cfg = self.cfg;
        self.destroyVideo()
        if (cfg && cfg.movieUrl) {
          let movie = cfg.movieUrl
          window.videoManager.currentVid = movie.ccvid
          /* 载入视频 */
          document.getElementById('video-container').innerHTML = ''
          let s = document.createElement('script')
          s.src = 'https://p.bokecc.com/player?' +
            'vid=' + movie.ccvid +
            '&siteid=' + movie.ccSiteId +
            '&autoStart=true' +
            '&width=100%' +
            '&height=100%' +
            '&playtype=1' +
            '&newversion=true'
          s.type = 'text/javascript'
          document.getElementById('video-container').appendChild(s)
        }
      }
    },
    beforeDestroy() {
			if(window.cc_js_Player) {
				window.cc_js_Player.destroy()
			}
		},
    beforeMount() {
      /*
       * TODO：应对视频销毁失败，如不使用cc提供的创建方法（需写死js文件）做的兼容处理
       * 每次初始化，增加一个video管理器队列，队列最大长度为5
       * 每次加载新视频，将队列里管理的视频（不包括新视频）元素全部暂停一次
       * 销毁时，所有视频元素都执行一次暂停
       */
      window.videoManager = {
        videoObjBuffer: [],
        currentVid: ''
      }
      window.on_CCH5player_ready = (obj) => {
        window.videoManager.videoObjBuffer.push(obj)
        if(window.videoManager.videoObjBuffer.length > 5) {
          window.videoManager.videoObjBuffer[0].videoElement.pause()
          window.videoManager.videoObjBuffer.shift()
        }
      }
    },
    mounted() {
      this.init();
    }
  };
</script>

<style scoped>
  .cc-video-viewer object,
  .cc-video-viewer embed {
    width: 100%;
    height: auto;
  }
</style>
